export const cnpjMask = (value: string) => {
    if (!value) return "";
    return value
        .replace(/\D/g, '') 
        .replace(/(\d{2})(\d)/, '$1.$2') 
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2') 
        .replace(/(-\d{2})\d+?$/, '$1'); 
};

export const formatCnpj = (cnpj: string) => {
    if (!cnpj) return '';

    return cnpj
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};